module.exports = "https://secnetweb.ksyun.com/KEC/ksc-node-kvm/assets/iconfont.a2e00e10b2c35f190c2dd139f69e6cf5.ttf";